<template>
    <div>
        <div class="header-box-wrapper">
            <div class="dis-flex align-items header-box">
                <section class="dis-flex align-items header-left">
                    <!-- <img src="@/assets/images/logo_nav.png" class="logo"> -->
                    <div class="navy">
                        <span :class="{'active': curNavy == 'home'}" @click="switchRoute('/home/dataBoard')">招考项目</span>
                        <span :class="{'active': curNavy == 'myExame'}" @click="switchRoute('/center/myExame')">我的考试</span>
                    </div>
                </section>
                <div class="dis-flex align-items person-info" v-if="token">
                    <section class="msg-box">
                        <el-dropdown @command="handleCommand">
                            <div class="dis-flex align-items message has-msg">
                                <i class="el-icon-message-solid"></i>
                                <span class="badge">{{unread}}</span>
                            </div>
                            <el-dropdown-menu slot="dropdown">
                                <div class="msg-title">我的通知</div>
                                <ul class="msg-list">
                                    <li class="active" @click="viewAllMsg" v-for="(item,index) in messageList" :key="index"><section><span v-if="item.is_read == 0">[新消息]</span>{{item.createtime | timeFormatting("y")}}  ：{{item.message}}</section></li>
                                    <!-- <li @click="viewAllMsg"><section>2020-05-11  ：您报名的考试【2020年观澜街道办招募社会临聘人</section></li>
                                    <li @click="viewAllMsg"><section>2020-05-11  ：您报名的考试【2020年观澜街道办招募社会临聘人</section></li>
                                    <li @click="viewAllMsg"><section>2020-05-11  ：您报名的考试【2020年观澜街道办招募社会临聘人</section></li> -->
                                </ul>
                                <div class="view-msg" @click="viewAllMsg">查看全部</div>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </section>
                    <section>
                        <el-dropdown @command="handleCommand">
                            <div class="dis-flex align-items">
                            <img src="@/assets/images/portal.png" class="portrai">
                            <div class="name">{{nickname}}</div>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="logOut" @click="handleCommand('logOut')">退出登录</el-dropdown-item>
                            </el-dropdown-menu>
                            </div>
                        </el-dropdown>
                    </section>
                </div>
                <div class="dis-flex align-items login-register" v-else>
                    <section class="login" @click="handleToLogin">登录</section>
                    <section class="register" @click="handleToRegister">注册</section>
                </div>
            </div>
        </div>
        <div class="mo-nav">
            <div class="dis-flex cur-nav">
                <section class="state">招考项目</section>
                <div class="dis-flex align-items icon-list">
                    <template v-if="token">
                        <div class="bell-box" @click="viewAllMsg"><i class="el-icon-bell"></i></div>
                        <div class="name">{{nickname}}, <a @click="isExit = true">退出</a></div>
                    </template>
                    <section class="dis-flex align-items icon-btn" @click="isShowNav = !isShowNav"><img src="@/assets/images/han.png"></section>
                </div>
                
            </div>
            <collapse>
                <ul v-if="isShowNav">
                    <li :class="{'active': curNavy == 'home'}" @click="switchRoute('/home/dataBoard')">招考项目</li>
                    <li :class="{'active': curNavy == 'myExame'}" @click="switchRoute('/center/myExame')">我的考试</li>
                </ul>
            </collapse>
        </div>
        <div class="header-kong"></div>
        <router-view />

        <div class="tip-contain" v-if="isExit">
            <div class="tip-con">
                <div class="tip-box">
                    <div class="tip-text">温馨提示</div>
                    <div class="warning">很抱歉，请用电脑打开使用</div>
                    <div class="dis-flex ope">
                        <section class="flex1 cancel" @click="isExit = false">取消</section>
                        <section class="flex1 yes" @click="handleCommand('logOut')">好的</section>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import routes from '@/router';
    import { dealCode } from '@/js/lib/dealCode';
    import collapse from "@/js/lib/collapse.js";

    export default {
        name: 'Main',
        components: {
            collapse
        },
        data() {
            return {
                nickname: localStorage.getItem('nickname'),
                token: localStorage.getItem('token'),
                // token: '',
                curNavy: '',
                isShowNav: false,
                page: 1,
                size: 5,
                total: null,
                unread: null,
                messageList: [],
                isExit: false
            }
        },
        created: function() {
            //监听页面刷新，菜单栏模块依旧高亮
            this.switchNavy(this.$route.path);
        },
        mounted(){
            if(this.token) this.getMessageList()
            this.$bus.$on('getMessageList',()=>{
                this.getMessageList()
            })
        },
        beforDestory () {
        　　this.$bus.$off('getMessageList', this.getMessageList())
        },
        methods: {
            switchRoute(val) {
                this.$router.push({path: val})
            },
            //退出登录
            handleCommand(command) {
                switch(command)
                    {
                    // case 'myInfo':
                    //     this.curNavy = '';
                    //     this.$router.push({path: '/center/myInfo'});
                    //     break;
                    // case 'myClass':
                    //     this.curNavy = '';
                    //     this.$router.push({path: '/center/myClass'});
                    //     break;
                    case 'logOut':
                        console.log('321')
                        window.localStorage.clear();
                        window.sessionStorage.clear();
                        this.$router.push({path: '/login'});
                        break;
                    default:
                        break;
                }
            },
            handleToLogin() {
                this.$router.push({'path': '/login'});
            },
            handleToRegister() {
                this.$router.push({'path': '/login?type=register'});
            },
            viewAllMsg() {
                this.$router.push({'path': '/center/informList'});
            },
            switchNavy(url) {
                if(url.indexOf('home') > -1) {
                    this.curNavy = 'home';
                }else if(url.indexOf('myExame') > -1) {
                    this.curNavy = 'myExame';
                }
            },
            getMessageList() {
                this.$http.post(API.frontendUserMessageList,{
                    'page': this.page,
                    'size': this.size
                }).then(res=> {
                    dealCode({
                        code: res.data.code,
                        successCallback: () => {
                            this.total = res.data.data.total
                            this.unread = res.data.data.unread
                            this.messageList = res.data.data.list
                        },
                        invalidUserCallback: () => {
                            this.$message.error(res.data.msg);
                        },
                        errorDeal: () => {
                            this.$message.error(res.data.msg);
                            this.password = '';
                        },
                        completeDeal: () => {
                            this.logging = false;
                        }
                    })
                })
            }
        },
        watch: {
            // 如果路由有变化，会再次执行该方法
            "$route": function(val) {
                this.switchNavy(val.path);
            }
        }
    }
</script>

<style scoped>
    @import './Main.css';
    
</style>


// WEBPACK FOOTER //
// src/components/main/Main.vue